import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SasSpinnerService } from '@app/shared/services/sas-spinner.service';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
    const spinnerService = inject(SasSpinnerService);

    const skipSpinner = req.headers.get('X-Skip-Spinner') === 'true';
    if (!skipSpinner) {
        spinnerService.setLoading(true);
    }

    return next(req).pipe(
        finalize(() => {
            if (!skipSpinner) {
                spinnerService.setLoading(false);
            }
        })
    );
}
